import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconAcceleration = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({}, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("path", { xmlns: "http://www.w3.org/2000/svg", d: "M21.31 11.66L20.45 9.84998L13.11 13.34C12.79 13.13 12.41 13 12 13C10.9 13 10 13.9 10 15C10 16.1 10.9 17 12 17C13.1 17 13.91 16.18 13.99 15.14L21.32 11.66H21.31Z" }),
            React.createElement("path", { xmlns: "http://www.w3.org/2000/svg", d: "M16.99 9.99995C16.99 9.99995 16.99 10.01 17 10.02L20.58 8.26995C18.89 6.03995 16.35 4.52995 13.69 4.13995C7.22002 3.05995 1.94002 8.32995 2.00002 14H2.99002C3.04002 13.55 3.13002 13.11 3.26002 12.68C4.95002 6.36995 13.46 4.71995 16.98 9.99995H16.99Z" }))));
};
